// The "Bump AI is watching" progress bar shown while a video processes (see useProcessingProgress).
import React, { useEffect, useState } from 'react';
import { BUMP_QUIPS } from './useProcessingProgress';
import './processingBar.css';

const pickQuip = () => Math.floor(Math.random() * BUMP_QUIPS.length);

export default function ProcessingBar({ percent }) {
  // A new quip every 7 seconds
  const [quip, setQuip] = useState(pickQuip);
  useEffect(() => {
    const iv = setInterval(() => setQuip(pickQuip()), 7000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="pbar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Processing video">
      <div className="pbar-head">
        <span className="pbar-pulse" aria-hidden="true" />
        <span key={quip} className="pbar-quip">{BUMP_QUIPS[quip]}</span>
        <span className="pbar-percent">{percent}%</span>
      </div>
      <div className="pbar-track">
        <div className="pbar-fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
